import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  navLinks = [
    { id: 'manjocarn', label: 'Manjocarn' },
    { id: 'restaurant', label: 'Restaurant' },
    { id: 'carte', label: 'La carte' },
    { id: 'evenements', label: 'Événements' },
    { id: 'activites', label: 'Activités' },
    { id: 'payer', label: 'Payer' },
    { id: 'instagram', label: 'Instagram' },
  ];

  hours = [
    { day: 'Lundi', hours: '09:00–00:30' },
    { day: 'Mardi', hours: '09:00–00:30' },
    { day: 'Mercredi', hours: '09:00–00:30' },
    { day: 'Jeudi', hours: '09:00–01:00' },
    { day: 'Vendredi', hours: '09:00–01:00' },
    { day: 'Samedi', hours: '09:00–01:00' },
    { day: 'Dimanche', hours: '10:00–23:30' },
  ];

  year = new Date().getFullYear();
}
